<template>
  <div class="cen">
     <table id="respTable">
  <thead>
    <tr>
      <th>Icon</th>
      <th>Transaction Name</th>
      <th>Payment Date</th>
      <th>Amount</th>
      <th>CommissionBalance</th>
      <th>Balance</th>
    </tr>
  </thead>
  <tbody>
    <tr class="cur" @click="showdialog(Transtion)" v-for="Transtion in Transtions" :key="Transtion.id">
        <td>
            <v-img height="25" width='25' v-if="Transtion.activity == 2" :src="require('../assets/frsc.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 3" :src="require('../assets/transfer.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 4" :src="require('../assets/NIS.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 5" :src="require('../assets/teller.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 6" :src="require('../assets/bank.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 7" :src="require('../assets/transfer.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 8" :src="require('../assets/jamb.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 9" :src="require('../assets/elect.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 10" :src="require('../assets/airTime.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 11" :src="require('../assets/cable.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 12" :src="require('../assets/net.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 13" :src="require('../assets/moneytransfer.png')"></v-img>
            <v-img height="25" width='25'  v-else-if="Transtion.activity == 14" :src="require('../assets/teller.png')"></v-img>
            <v-img height="25" width='25' v-else :src="require('../assets/teller.png')"></v-img>
        </td>
      <td>
           <span class="titl" v-if="Transtion.activity == 2">FRSC DRIVER'S LICENSE </span>
                   <span class="titl" v-else-if="Transtion.activity == 3">REVERSAL </span>
                    <span class="titl" v-else-if="Transtion.activity == 4">NIS PAYMENT </span>
                      <span class="titl" v-else-if="Transtion.activity == 5">MANUAL CREDIT </span>
                      <span class="titl" v-else-if="Transtion.activity == 6">BANK TRANSFER DEPOSIT </span>
                   <span class="titl" v-else-if="Transtion.activity == 7">BANK TRANSFER WITHDRAWAL </span>
                    <span class="titl" v-else-if="Transtion.activity == 8">JAMB PAYMENT </span>
                     <span class="titl" v-else-if="Transtion.activity == 9">ELECTRICITY </span>
                <span class="titl" v-else-if="Transtion.activity == 10">AIRTIME PURCHASE  -{{Transtion.additional.network}} </span>
                     <span class="titl" v-else-if="Transtion.activity == 11">CABLE (TV) </span>
                    <span class="titl" v-else-if="Transtion.activity == 12">INTERNET  </span>
               <span class="titl" v-else-if="Transtion.activity == 13"> PERSONAL TRANSFER  </span>
                  <span class="titl" v-else-if="Transtion.activity == 14"> POS CREDIT  </span>
             <span class="titl" v-else>View Details</span>
      </td>
        <td class="titl">{{DisplayTime(Transtion.timestamp)}}</td>
        <td class="titl">{{DisplayCurrency(Transtion.amount/100)}}</td>
        <td class="titl">{{DisplayCurrency(Transtion.commissionBalanceAfterTransaction/100)}}</td>
        <td class="titl">{{DisplayCurrency(Transtion.mainBalanceAfterTransaction/100) }}</td>   
    </tr>
  </tbody>
</table>
   <v-dialog v-model="dialog" width="600px">
        <v-card>
        <v-card-title>
          <span class="headline">Transaction Details</span>
        </v-card-title>
        <v-card-text>
          <span v-if="detail.additional">Reference ID:  {{detail.additional.reference}} {{detail.additional.referenceId}} </span>
          <br>
          <span v-if="detail.timestamp">Date: {{DisplayTime(detail.timestamp)}}</span>
          <br>
          <span v-if="detail.timestamp">Amount: {{DisplayCurrency(detail.amount/100)}}</span>
          <br>
           <span v-if="detail.timestamp">Balance After Transaction: {{DisplayCurrency(detail.mainBalanceAfterTransaction/100)}}</span>
          <br>
           <span v-if="detail.timestamp">Commission Balance After Transaction: {{DisplayCurrency(detail.commissionBalanceAfterTransaction/100)}}</span>
          <br>
        </v-card-text>
           <v-card-title>
          <span class="headline">Additional Info</span>
        </v-card-title>
        <v-card-text v-if="detail.additional">
        <span v-if="detail.additional.tvNetwork">TV Network: {{detail.additional.tvNetwork}}</span>
          <br v-if="detail.additional.tvNetwork">
        <span v-if="detail.additional.reference">Reference: {{detail.additional.reference}}</span>
          <br v-if="detail.additional.reference">
        <span v-if="detail.additional.mobileNumber">Mobile Number: {{detail.additional.mobileNumber}}</span>
          <br v-if="detail.additional.mobileNumber">
        <span v-if="detail.additional.destBank">Bank: {{detail.additional.destBank}}</span>
          <br v-if="detail.additional.destBank">
        <span v-if="detail.additional.accountNumber">Account Number: {{detail.additional.accountNumber}}</span>
          <br v-if="detail.additional.accountNumber">
        <span v-if="detail.additional.accountName">Account Name: {{detail.additional.accountName}}</span>
          <br v-if="detail.additional.accountName">

           <span v-if="detail.additional.appID">App ID: {{detail.additional.appID}}</span>
          <br v-if="detail.additional.appID">
           <span v-if="detail.additional.payBillTxnID">TxnID: {{detail.additional.payBillTxnID}}</span>
          <br v-if="detail.additional.payBillTxnID">
           <span v-if="detail.additional.applicantFirstname">FullName: {{detail.additional.applicantFirstname}} {{detail.additional.applicantLastname}}</span>
          <br v-if="detail.additional.applicantFirstname">
          <span v-if="detail.additional.candidateFirstName">Candidate Name: {{detail.additional.candidateFirstName}} {{detail.additional.candidateLastName}}</span>
          <br v-if="detail.additional.candidateFirstName">
           <span v-if="detail.additional.pin">Pin: {{detail.additional.pin}}</span>
          <br v-if="detail.additional.pin">
           <span v-if="detail.additional.confirmationCode">Confirmation Code: {{detail.additional.confirmationCode}}</span>
          <br v-if="detail.additional.confirmationCode">
             <span v-if="detail.additional.meterToken">Meter Token: {{detail.additional.meterToken}}</span>
          <br v-if="detail.additional.meterToken">
            <span v-if="detail.additional.units">Units: {{detail.additional.units}}</span>
          <br v-if="detail.additional.units">
            <span v-if="detail.additional.accountFrom">From: {{detail.additional.accountFrom}}</span>
          <br v-if="detail.additional.accountFrom">
          <span v-if="detail.additional.accountTo">To: {{detail.additional.accountTo}}</span>
          <br v-if="detail.additional.accountTo">

          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">Okay</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import currencyFormatter from 'currency-formatter'
import dayjs from "dayjs";


  export default {
      props:["Transtions"],
      created() {
          console.log(this.Transtions, "PPPP")
      },
    data () {
      return {
        dialog:false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        detail:{}
      }
    },
    methods: {
        showdialog(payload){
        this.dialog= true
        this.detail= payload
      },
        DisplayTime(payload){
                if (payload) {
                return dayjs(payload).format('MMM D, YYYY')
            }
        },
           DisplayCurrency(payload) {
      return currencyFormatter.format(payload, {
        code: "NGN"
      });
    },
    },
  }
</script>
<style lang="scss" scoped>

main {
  display: flex;
  justify-content: center;
}
span{
  text-transform: capitalize !important;
}
.titl{
  font-size: 14px;
}

table {
  max-width: 100%;
}

tr:nth-child(odd) {
  background-color: #eee;
}
tr{
    cursor: pointer;
}

th {
  background-color: #AD1684;
  color: #fff;
}

th,
td {
  text-align: left;
  padding: 0.5em 1em;
}

td::before {
  display: none;
}

@media screen and (max-width: 680px) {
 table {
   border: 0;
   display: block;
   box-shadow: none;
 }

 thead {
   position: absolute;
   opacity: 0;
 }
  
 tbody {
   display: block;
   min-width: 19em;
   max-width: 25em;
 }
}
</style>